import React from 'react';
import { ArrowUpward as ArrowIcon } from '@mui/icons-material';
import * as S from './styles';

interface IPriceDiffPercentProps {
  diffPercent: number;
}

function PriceDiffPercent({ diffPercent }: IPriceDiffPercentProps) {
  const formattedPriceDiffPercent = `(${diffPercent.toFixed(2)}%)`;
  const haveDiscount = (value: number) => {
    if (value === 0) return true;

    return value < 0;
  };

  return (
    <S.Container $isDiscount={haveDiscount(diffPercent)}>
      {formattedPriceDiffPercent}
      {diffPercent !== 0 ? <ArrowIcon fontSize="small" /> : <></>}
    </S.Container>
  );
}

export default PriceDiffPercent;
